import type { DepthInfo, ImageInfo } from "@shared/types/annotations";

import { imagePxToDepthPx } from "@/lib/measurement/depth3d";
import type { AnnotationViewport } from "../AnnotationViewerBase/helpers";

interface DepthDebugTransform {
  translateX: number;
  translateY: number;
  scale: number;
}

const finiteOr = (value: number, fallback: number) => (Number.isFinite(value) ? value : fallback);

export function computeDepthDebugTransform(
  viewport: AnnotationViewport,
  image: ImageInfo,
  depth: DepthInfo,
  panelWidth: number,
  panelHeight: number
): DepthDebugTransform {
  const zoom = Math.max(1, finiteOr(viewport.zoom, 1));
  const center = {
    x: Math.min(1, Math.max(0, finiteOr(viewport.center.x, 0.5))),
    y: Math.min(1, Math.max(0, finiteOr(viewport.center.y, 0.5))),
  };
  const depthCenter = imagePxToDepthPx({ x: center.x * image.width, y: center.y * image.height }, image, depth);
  const baseScaleX = panelWidth / depth.width;
  const baseScaleY = panelHeight / depth.height;
  return {
    translateX: panelWidth / 2 - depthCenter.u * baseScaleX * zoom,
    translateY: panelHeight / 2 - depthCenter.v * baseScaleY * zoom,
    scale: zoom,
  };
}
